/**
 * @license 2023-04-10 박주형
 * header.component는 한국어 앱에서 동명의 컴포넌트가 아니라 left-menu.component와 더 유사한 컴포넌트임.
 */
import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, Renderer2, OnDestroy} from '@angular/core';
import {Router} from "@angular/router";

import {MENU_PAGE} from '../../defines/desktop.const';
import {BBS_CATEGORY} from "../../defines/protocol";
import {LIST_TYPE, SearchParam} from "../../defines/client.const";
import {SetHtmlLargeMode} from "../../defines/client.func";
import {OptionService} from "../../services/option/option.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {LastIdService} from "../../services/last-id/last-id.service";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements AfterViewInit, OnDestroy {
  @Input() selectedMenu: MENU_PAGE = MENU_PAGE.NONE;
  @Output() clickHome = new EventEmitter();

  MENU_PAGE = MENU_PAGE;
  LIST_TYPE = LIST_TYPE;
  BBSCategory = BBS_CATEGORY;

  public showBookmarkSubMenu: boolean = false;

  private clickSubscription: any;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private router: Router,
    private option: OptionService,
    private lastIdSvc: LastIdService,
    private globalEventSvc: GlobalEventService,
  ) {
  }

  ngAfterViewInit(): void {
    this.clickSubscription = this.globalEventSvc.Click$.subscribe(() => this.showBookmarkSubMenu = false);
  }

  ngOnDestroy(): void {
    if (this.clickSubscription) {
      this.clickSubscription.unsubscribe();
      this.clickSubscription = null;
    }
  }

  public get isBookmarkPage(): boolean {
    // console.warn('isBookmarkPage =', this.selectedMenu);

    switch (this.selectedMenu) {
      case MENU_PAGE.WORD_BOOKMARK:
      case MENU_PAGE.DIALECT_BOOKMARK:
      // #452: 속담 책갈피 메뉴는 임시 비활성화. 재활성화 시 bookmark page 판정을 복구한다.
      // case MENU_PAGE.PROVERB_BOOKMARK:
      case MENU_PAGE.SASEUNG_BOOKMARK:
      case MENU_PAGE.SAJASEUNGEO_BOOKMARK:
      case MENU_PAGE.MOVIE_BOOKMARK:
        return true;
    }
    return false;
  }

  public get isWordPage(): boolean {
    switch (this.selectedMenu) {
      case MENU_PAGE.WORD:
      case MENU_PAGE.WORD_BOOKMARK:
      case MENU_PAGE.WORD_HISTORY:
        return true;
    }
    return false;
  }

  public get isDialectPage(): boolean {
    switch (this.selectedMenu) {
      case MENU_PAGE.DIALECT:
      case MENU_PAGE.DIALECT_BOOKMARK:
      case MENU_PAGE.DIALECT_HISTORY:
        return true;
    }
    return false;
  }

  public get isProverbPage(): boolean {
    switch (this.selectedMenu) {
      case MENU_PAGE.PROVERB:
      // #452: 속담 책갈피 메뉴는 임시 비활성화. 재활성화 시 proverb bookmark 판정을 복구한다.
      // case MENU_PAGE.PROVERB_BOOKMARK:
      case MENU_PAGE.PROVERB_HISTORY:
        return true;
    }
    return false;
  }

  public get isMoviePage(): boolean {
    switch (this.selectedMenu) {
      case MENU_PAGE.MOVIE_COLLECT:
      case MENU_PAGE.MOVIE_BOOKMARK:
      case MENU_PAGE.MOVIE_HISTORY:
        return true;
    }
    return false;
  }

  public get isSaseungPage(): boolean {
    switch (this.selectedMenu) {
      case MENU_PAGE.SASEUNG:
      case MENU_PAGE.SASEUNG_BOOKMARK:
        return true;
    }
    return false;
  }

  public get isSajaseungeoPage(): boolean {
    switch (this.selectedMenu) {
      case MENU_PAGE.SAJASEUNGEO:
      case MENU_PAGE.SAJASEUNGEO_BOOKMARK:
        return true;
    }
    return false;
  }

  public get getLargeModeTxt(): string {
    return this.option.largeMode ? '글씨 크기 줄이기' : '글씨 크게 보기';
  }

  public ToggleLargeMode($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    const value = !this.option.largeMode;
    this.option.largeMode = value;
    SetHtmlLargeMode(this.renderer, this.el, value);
    window.location.reload();
  }

  protected onClickHome($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    this.clickHome.emit($event);
  }

  protected onToggleBookmarkSubMenu($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    this.showBookmarkSubMenu = !this.showBookmarkSubMenu;
  }

  protected onCloseBookmarkSubMenu(): void {
    this.showBookmarkSubMenu = false;
  }

  protected onClickWord($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    // const [detail_id, list_id] = this.lastIdSvc.getLastWordId();
    const queryParams: SearchParam = {
      // ...(detail_id ? {id: detail_id} : {}),
      // ...(list_id ? {start: list_id} : {}),
    };
    this.router.navigate(['/word', LIST_TYPE.SERVER], {queryParams}).then();
  }

  protected onClickSajaseungeo($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    // const [detail_id, list_id] = this.lastIdSvc.getLastSajaseungeoId();
    const queryParams: SearchParam = {
      // ...(detail_id ? {id: detail_id} : {}),
      // ...(list_id ? {start: list_id} : {}),
    };
    this.router.navigate(['/sajaseungeo', LIST_TYPE.SERVER], {queryParams}).then();
  }

  protected onClickHomonym($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event);

    // const [detail_id, list_id] = this.lastIdSvc.getLastHomonymId();
    const queryParams: SearchParam = {
    };
    this.router.navigate(['/homonym'], {queryParams}).then();
  }
}
